import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {
  IAccountFormPayload,
  ICustomerProfile,
  IEditAccountDetails,
  IOrganizationPayload,
} from '../models/accounts.model';
import {ICustomerRequest} from '../models/customer-request.model';
import {ICustomerResponse} from '../models/customer-response.model';
import {ILinkCustomerOrganizationResponse} from '../models/link-customer-organization.model';
import {IRole} from '../models/role.model';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  private readonly _httpClient = inject(HttpClient);

  private readonly getCustomersUrl = `${environment.api.baseUrl}/${environment.api.identity.getCustomersByOrganizationId}`;
  private readonly getRolesUrl = `${environment.api.baseUrl}/${environment.api.identity.getRoles}`;
  private readonly updateOrganizationUrl = `${environment.api.baseUrl}/${environment.api.organization.updateCustomerOrganizationStatus}`;
  private readonly saveAccountUrl = `${environment.api.baseUrl}/${environment.api.account.addNewCustomer}`;
  private readonly updateAccountUrl = `${environment.api.baseUrl}${environment.api.header.updateCustomerProfile}`;
  private readonly getCustomerUrl = `${environment.api.baseUrl}/${environment.api.account.getCustomer}`;

  getCustomers(request: ICustomerRequest): Observable<ICustomerResponse> {
    return this._httpClient.post<ICustomerResponse>(`${this.getCustomersUrl}/${request.organizationId}`, request);
  }

  getRoles(): Observable<IRole[]> {
    return this._httpClient.get<IRole[]>(this.getRolesUrl);
  }

  updateCustomerOrganizationStatus(payload: IOrganizationPayload): Observable<ILinkCustomerOrganizationResponse> {
    let params = new HttpParams();
    if (payload.customerId) {
      params = params.set('customerId', payload.customerId);
    }
    if (payload.organizationId) {
      params = params.set('organizationId', payload.organizationId);
    }
    if (payload.statusId) {
      params = params.set('statusId', payload.statusId);
    }

    return this._httpClient.put<ILinkCustomerOrganizationResponse>(this.updateOrganizationUrl, null, {
      params,
    });
  }

  saveAccount(payload: IAccountFormPayload): Observable<ICustomerProfile> {
    return this._httpClient.post<ICustomerProfile>(this.saveAccountUrl, payload);
  }

  updateAccount(payload: IAccountFormPayload): Observable<ICustomerProfile> {
    return this._httpClient.put<ICustomerProfile>(this.updateAccountUrl, payload);
  }

  getEditAccountDetails(id: number, organizationId: number): Observable<IEditAccountDetails> {
    const requestUrl = `${this.getCustomerUrl}/${id}?organizationId=${organizationId}`;

    return this._httpClient.get<IEditAccountDetails>(requestUrl);
  }
}
